import React from "react";
import ReactDOM from "react-dom";

import { WindowWithExternalAppComponents } from "fe-shared/src/types/common";

import App from "components/App";

import "./i18n";
import "fe-shared-transactions/src/i18n";
import "fe-shared/src/i18n";
import * as serviceWorker from "./serviceWorker";

const extendedWindow = window as WindowWithExternalAppComponents;

if (!extendedWindow.externalAppComponents) {
  extendedWindow.externalAppComponents = {};
}

extendedWindow.externalAppComponents.Transactions = App;

// render in standalone mode

const rootElement = document.getElementById("root");

if (!rootElement?.children.length) {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootElement
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
